export default "__VITE_ASSET__a3c36d0a__"